module.exports = __webpack_public_path__ + "media/images/btn_new_member01-64ce2f91248705eb030c1abb5b622531.svg";